import React, { useState, useEffect, useRef } from "react";
import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
//import { MdCloudUpload } from "react-icons/md";
import { Modal, Button } from "react-bootstrap";
import ThumbnailUpload from "./ThumbnailUpload";
import { useNavigate } from "react-router-dom";
import { syncImageUrls, getStorageUrls } from "../functions/syncImages";

const ImageUploadModal = ({ docId, imageUrls }) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isThumbnailUploadVisible, setIsThumbnailUploadVisible] =
    useState(true); // Initially set to true
  const [showModal, setShowModal] = useState(true); // Show the modal initially
  const fileInputRef = useRef(null); // Create a ref for the file input

  const isImageFile = (file) => {
    const allowedExtensions = ["jpg", "jpeg", "png", "gif", "heic", "raw"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return allowedExtensions.includes(fileExtension);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (file && isImageFile(file)) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
      alert("Please select a valid image file (jpg, jpeg, png, gif).");
    }
  };

  const uploadImage = async () => {
    if (!selectedFile) {
      alert("Please select an image before uploading.");
      return;
    }
    //artist stored in local storage
    const artist = localStorage.getItem("fullName");

    if (artist === null) {
      alert("Please Register or Sign In");
      return;
    }
    setIsUploading(true);
    const storageRef = ref(
      storage,
      `images/${artist}/${artist}_${selectedFile.name}`
    );

    try {
      await uploadBytes(storageRef, selectedFile);
      console.log("File uploaded successfully.");
      const url = await getDownloadURL(storageRef);
      console.warn(`StorageRef Url has: ${url}`);
      setIsThumbnailUploadVisible(true); // Ensure it's set to true when successful
    } catch (error) {
      alert("There was an error in uploading the file, please try again.");
    } finally {
      const collectionName = "artists";
      if (syncImageUrls(collectionName, docId, imageUrls)) {
        console.log("Successful Sync after Upload");
      }
      setIsUploading(false);
      navigate("/Gallery"); // Replace with the actual path to your "ImageUpload" route
    }
  };

  useEffect(() => {
    // Automatically open the file input when the component is mounted
    fileInputRef.current.click();
  }, []);

  const handleUploadClick = () => {
    setShowModal(true); // Open the modal
  };

  const closeModal = () => {
    setShowModal(false); // Close the modal
  };

  return (
    <>
      <div>
        {/* Hidden file input */}
        <input
          ref={fileInputRef}
          type='file'
          className='input-field'
          hidden
          id='customFile'
          accept='.jpg, .jpeg, .png, .gif'
          onChange={handleFileChange}
        />
      </div>

      {/* Modal for Image Upload */}
      <Modal
        className='custom-modal'
        show={showModal}
        onHide={closeModal}
        backdrop='static'
        keyboard={false}>
        <Modal.Body className=' mx-auto'>
          {isThumbnailUploadVisible && selectedFile && (
            <ThumbnailUpload
              className='mx-auto'
              selectedFile={selectedFile}
              isUploading={isUploading}
              uploadImage={uploadImage}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageUploadModal;
